export default "__VITE_ASSET__C$j7do6u__"